import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'account-settings-manage-assets',
		path: '/account_settings/manage_assets',
		component: loadable(async () => import(/* webpackChunkName: "pages/accountSettings-manageAssets" */ './index'), {
			exportName: 'AccountSettingsManageAssets',
			fallback: Loading,
		}),
		frame: true,
		restrictedAccess: {
			authOnly: true,
			role: ['staff'],
		},
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
